import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'


const offerKlarnaWedgit = (onload, klarnaId) => {
	const klarnaScript = document.getElementById('klarna-wedgit-script')
	if(!klarnaScript){
		const head = document.getElementsByTagName('head')[0]
		const script = document.createElement('script')
		script.type = 'text/javascript'
		script.id = 'klarna-wedgit-script'
		script.async = true
		script.src = "https://na-library.klarnaservices.com/lib.js"
        script.setAttribute('data-client-id', klarnaId)
		script.onload = onload
		head.appendChild(script)
	}else{
		onload()
	}
}


export default props => {
    const { amount } = props
    const global = useSelector(state => state.global)

    useEffect(() => {
        if(global?.config?.klarna?.clientId){
            offerKlarnaWedgit(() => {
                
            }, global?.config?.klarna?.clientId)
        }
        
    }, [])


    return <klarna-placement
        data-key="credit-promotion-badge"
        data-locale="en-US"
        data-purchase-amount={(Number(amount)*100).toFixed(0)}>

        </klarna-placement >
}